import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import { Loader2 } from "lucide-react";

const RequireAdmin = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const stateValue = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-[#12964A] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" state={stateValue} replace />;
  return children;
};

export default RequireAdmin;
